/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Banner,
  Button,
  Card,
  Layout,
  Link,
  TextContainer,
} from '@shopify/polaris';
import styleConstants from 'src/styles/constants';
import { useTenantContext } from 'src/components/TenantProvider';
import getDeepLink from 'src/utils/getDeepLink';
import {
  BANNER,
  REQUIRED_SETUP,
  GETTING_STARTED,
  LEARN_MORE,
  RESOURCES,
  GET_IN_TOUCH,
} from './constants';
import DisconnectSection from './DisconnectSection';

const SetUpComponent = () => {
  const {
    tenant: { subdomain },
  } = useTenantContext();

  return (
    <>
      <Banner>
        <p>{BANNER.text}</p>
      </Banner>
      <br />
      <Layout>
        <Layout.AnnotatedSection title={REQUIRED_SETUP.title}>
          <Card sectioned>
            <TextContainer>
              <p>{REQUIRED_SETUP.text}</p>
              <Button url={REQUIRED_SETUP.button.url} external primary>
                {REQUIRED_SETUP.button.text}
              </Button>
            </TextContainer>
          </Card>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={GETTING_STARTED.title}>
          <Card>
            <Card.Section>
              <TextContainer>
                <p>{GETTING_STARTED.texts[0]}</p>
                <Link url={GETTING_STARTED.links[0]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{GETTING_STARTED.texts[1]}</p>
                <Link url={GETTING_STARTED.links[1]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{GETTING_STARTED.texts[2]}</p>
                <Link url={GETTING_STARTED.links[2]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{GETTING_STARTED.texts[3]}</p>
                <div className="customize__button__container">
                  <Button
                    url={getDeepLink(
                      subdomain,
                      'manage/notifications#student-email-notifications'
                    )}
                    external
                  >
                    {GETTING_STARTED.button}
                  </Button>
                </div>
                <Link url={GETTING_STARTED.links[3]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{GETTING_STARTED.texts[4]}</p>
                <Link url={GETTING_STARTED.links[4]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={RESOURCES.title}>
          <Card>
            <Card.Section>
              <TextContainer>
                <p>{RESOURCES.texts[0]}</p>
                <Link url={RESOURCES.links[0]} external>
                  {RESOURCES.linksText}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{RESOURCES.texts[1]}</p>
                <Link url={RESOURCES.links[1]} external>
                  {RESOURCES.linksText}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{RESOURCES.texts[2]}</p>
                <Link url={RESOURCES.links[2]} external>
                  {RESOURCES.linksText}
                </Link>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>
        <DisconnectSection />
        <Layout.AnnotatedSection title={GET_IN_TOUCH.title}>
          <Card>
            <Card.Section subdued>
              <TextContainer>
                <p>{GET_IN_TOUCH.text}</p>
                <Button url={GET_IN_TOUCH.button.value} external primary>
                  {GET_IN_TOUCH.button.text}
                </Button>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
      <style jsx>{`
        .customize__button__container {
          display: inline;
          margin-right: ${styleConstants.spacing.four};
        }
      `}</style>
    </>
  );
};

export default SetUpComponent;
